'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botSessionDetails = require('./bot-session-details.html');

var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);

var _botSessionDetails3 = require('./bot-session-details.controller');

var _botSessionDetails4 = _interopRequireDefault(_botSessionDetails3);

require('./bot-session-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botSessionDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template: _botSessionDetails2.default,
  controller: _botSessionDetails4.default,
  controllerAs: 'vm'
};

exports.default = botSessionDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-session-details/bot-session-details.component.js
 **/